<template>
  <v-container>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="articles"
          item-key="key"
          sort-by="pos"
          group-by="pos"
          class="elevation-1"
          show-group-by
          :items-per-page="-1"
          hide-default-footer
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Angebot',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      articles: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         headers: [
            { text: 'Pos-Text', value: 'pos', align: 'left', width: '200px', sort: function (a, b) { return parseFloat(a) - parseFloat(b) } },
            { text: 'Article', value: 'name', align: 'left', width: '400px', sortable: false },
            { text: 'Anzahl', value: 'amount', align: 'left', groupable: false, sortable: false },
         ],
      }
   }

}
</script>

<style>

</style>
